import { ParkingSubscriptionStatus } from '../graphql/tenant/getTenant'

interface ICancelledDaySource {
  day: string
  cancelledAt?: string | null
  cancelledBy?: string | null
  poolParking?: {
    parking?: {
      name: string
    } | null
  } | null
}

export interface ICancellationSource {
  id?: string | number
  validFrom: string
  validTo: string
  status: ParkingSubscriptionStatus
  cancelledAt?: string | null
  cancelledBy?: string | null
  parkingPass?: {
    parking?: {
      name: string
    } | null
  } | null
  cancelledDays?: ICancelledDaySource[] | null
}

export interface ICancellationEvent {
  key: string
  kind: 'subscription' | 'day'
  day?: string
  validFrom: string
  validTo: string
  cancelledAt?: string | null
  cancelledBy?: string | null
  parking?: string | null
  dayCount: number
}

const dayOf = (iso: string) => iso.slice(0, 10)

const byCancelledAtDesc = (a: ICancellationEvent, b: ICancellationEvent) =>
  (b.cancelledAt ?? '').localeCompare(a.cancelledAt ?? '') ||
  (b.day ?? b.validFrom).localeCompare(a.day ?? a.validFrom)

export const cancellationEvents = (
  subscriptions: ICancellationSource[],
): ICancellationEvent[] => {
  const events: ICancellationEvent[] = []

  subscriptions.forEach((sub, index) => {
    const subId = String(sub.id ?? index)
    const passParking = sub.parkingPass?.parking?.name ?? null
    const days = sub.cancelledDays ?? []

    if (sub.status === ParkingSubscriptionStatus.cancelled) {
      events.push({
        key: `sub-${subId}`,
        kind: 'subscription',
        validFrom: sub.validFrom,
        validTo: sub.validTo,
        cancelledAt: sub.cancelledAt ?? days[0]?.cancelledAt ?? null,
        cancelledBy: sub.cancelledBy ?? days[0]?.cancelledBy ?? null,
        parking: passParking,
        dayCount: days.length,
      })
      return
    }

    days.forEach(slot => {
      events.push({
        key: `day-${subId}-${slot.day}`,
        kind: 'day',
        day: slot.day,
        validFrom: sub.validFrom,
        validTo: sub.validTo,
        cancelledAt: slot.cancelledAt ?? null,
        cancelledBy: slot.cancelledBy ?? null,
        parking: slot.poolParking?.parking?.name ?? passParking,
        dayCount: 1,
      })
    })
  })

  return events.sort(byCancelledAtDesc)
}

export const cancelledOnReservationDay = (
  event: ICancellationEvent,
): boolean => {
  if (!event.cancelledAt) return false
  const reservedDay = event.day ?? event.validFrom
  return dayOf(event.cancelledAt) >= dayOf(reservedDay)
}
